export const isCountryAt = (() => {
  if (typeof document === 'undefined') {
    // Don't proceed in Node.js context for the processTranslations Gulp task
    return false;
  }
  return document.documentElement.lang === 'de-AT';
})();

export const isCountryNl = (() => {
  if (typeof document === 'undefined') {
    // Don't proceed in Node.js context for the processTranslations Gulp task
    return false;
  }
  return document.documentElement.lang === 'nl' ||
    document.documentElement.lang === 'nl-NL';
})();
